import type { ConnectedProjectDto } from "@/api/types";
import {
  canRoleTypeAccessAnalytics,
  canRoleTypeAccessOperationalAnalyticsSummary,
} from "@/components/ProjectSidebar/permissions";

interface PortfolioTicketProjectScopeArgs {
  linkedProjects: ConnectedProjectDto[];
  projectsInScope: ConnectedProjectDto[];
  projectIdsToFilter: string[] | undefined;
}

interface PortfolioTicketProjectScope {
  projects: ConnectedProjectDto[];
  preserveProjectFiltersInDetailsLink: boolean;
}

/** Resolves the project scope the ticket API effectively uses after its URL-size fallback. */
export function resolvePortfolioTicketProjectScope({
  linkedProjects,
  projectsInScope,
  projectIdsToFilter,
}: PortfolioTicketProjectScopeArgs): PortfolioTicketProjectScope {
  if (projectIdsToFilter === undefined) {
    return {
      projects: linkedProjects,
      preserveProjectFiltersInDetailsLink: false,
    };
  }

  return {
    projects: projectsInScope,
    preserveProjectFiltersInDetailsLink: true,
  };
}

/** Whether every project in the effective ticket scope permits detailed analytics. */
export function canAccessPortfolioTicketAnalyticsDetails(projects: ConnectedProjectDto[]): boolean {
  return projects.length > 0 && projects.every((project) => canRoleTypeAccessAnalytics(project.userRole));
}

/** Whether every project in the effective ticket scope permits aggregate analytics. */
export function canAccessPortfolioTicketOperationalAnalyticsSummary(projects: ConnectedProjectDto[]): boolean {
  return (
    projects.length > 0 && projects.every((project) => canRoleTypeAccessOperationalAnalyticsSummary(project.userRole))
  );
}
